import React from 'react';
import { LLEmojiSliderWidgetSubmitButton } from './LLEmojiSliderWidgetSubmitButton';
import { LLWidgetActionInfo, LLWidgetActionInfoProps } from '../LLWidgetFooter';

export function LLEmojiSliderWidgetActionInfo(props: LLWidgetActionInfoProps) {
  return (
    <LLWidgetActionInfo
      {...props}
      SubmitButtonComponent={LLEmojiSliderWidgetSubmitButton}
    />
  );
}
